import * as React from "react";
import { SVGProps } from "react";

const Xrp = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 424" {...props}>
    <path
      fill="#23292f"
      d="M437 0h74L357 152.48c-55.77 55.19-146.19 55.19-202 0L.94 0H75l117 115.83a91.11 91.11 0 0 0 127.91 0ZM74.05 424H0l155-153.42c55.77-55.19 146.19-55.19 202 0L512 424h-74L320 307.23a91.11 91.11 0 0 0-127.91 0Z"
    />
  </svg>
);

export default Xrp;
